import { render, staticRenderFns } from "./ProofOfServiceInstructions.vue?vue&type=template&id=2474117e&scoped=true"
import script from "./ProofOfServiceInstructions.vue?vue&type=script&lang=ts"
export * from "./ProofOfServiceInstructions.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=2474117e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474117e",
  null
  
)

export default component.exports